import { WEB_ROUTES } from "../routes/web-routes";
import { NavLink } from "react-router-dom";

function stripHtml(html) {
  return (
    html
      ?.replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim() ?? ""
  );
}

export default function LeadershipItem({ member, memberMedia, type = "main" }) {
  const blurb = stripHtml(member?.content?.rendered);
  const snippet =
    blurb.length > 200 ? blurb.slice(0, 200).trimEnd() + "…" : blurb;

  return (
    <div className="group flex gap-6 items-start mb-10">
      <NavLink
        to={WEB_ROUTES.LEADERSHIP + "/" + member?.slug}
        className="flex-shrink-0"
      >
        <div className="w-40 h-40 rounded-full overflow-hidden">
          <img
            src={memberMedia?.source_url}
            alt={member?.title?.rendered}
            className="w-full h-full object-cover transition duration-700 ease-in-out group-hover:scale-110"
          />
        </div>
      </NavLink>

      <div className="flex flex-col">
        <h4 className="font-medium text-[#0070b9] mb-0.5">
          <NavLink to={WEB_ROUTES.LEADERSHIP + "/" + member?.slug}>
            {member?.title?.rendered}
          </NavLink>
        </h4>
        <p className="font-semibold text-[#58b947] mb-2">
          {member?.acf?.job_title}
        </p>
        {snippet && <p className="leading-relaxed mb-3">{snippet}</p>}
        <NavLink
          to={WEB_ROUTES.LEADERSHIP + "/" + member?.slug}
          className="text-[#0070b9] font-medium"
        >
          Read more →
        </NavLink>
      </div>
    </div>
  );
}
